import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  unreadCount: 0,
  initialized: false,
  loading: false,
  hasMore: false,
  lastId: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.items = action.payload;
      state.initialized = true;
      state.unreadCount = action.payload.filter(
        (n) => n.isViewed === false
      ).length;
    },
    appendNotifications: (state, action) => {
      const { notifications, hasMore, lastId } = action.payload;
      const existingIds = new Set(state.items.map((n) => n.id));
      const newItems = (notifications || []).filter(
        (n) => n?.id && !existingIds.has(n.id)
      );
      state.items = [...state.items, ...newItems];
      state.hasMore = hasMore;
      state.lastId = lastId;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    setLastId: (state, action) => {
      state.lastId = action.payload;
    },
    markViewed: (state, action) => {
      const id = action.payload;
      const notif = state.items.find((n) => n.id === id);
      if (notif) {
        notif.isViewed = true;
        state.unreadCount = state.items.filter(
          (n) => n.isViewed === false
        ).length;
      }
    },
    markAllViewed: (state) => {
      state.items.forEach((n) => {
        n.isViewed = true;
      });
      state.unreadCount = 0;
    },
    resetNotifications: () => initialState,
  },
});

export const {
  setNotifications,
  appendNotifications,
  setLoading,
  setHasMore,
  setLastId,
  markViewed,
  markAllViewed,
  resetNotifications,
} = notificationsSlice.actions;

export const selectNotifications = (state) => state.notifications.items;
export const selectUnreadCount = (state) => state.notifications.unreadCount;
export const selectNotificationsLoading = (state) => state.notifications.loading;
export const selectHasMoreNotifications = (state) => state.notifications.hasMore;
export const selectLastNotificationId = (state) => state.notifications.lastId;

export default notificationsSlice.reducer;
